import React from "react";
import { Copy, Download, Share2, Check } from "lucide-react";
import { Button } from "../ui/button";
import { SocialShareRow } from "./SocialShareRow";

export function ShareActions({ shareUrl, imageUrl, caption, copied, copyLink, nativeShare, downloadPng, getPngFile }) {
  return (
    <>
      <div className="mt-4 flex items-center gap-2 min-w-0 px-3 py-2 rounded-md border border-white/10 bg-white/5" data-testid="postcard-link-row">
        <span className="text-[11px] text-[#A89C98] truncate font-mono-scanner flex-1 min-w-0">{shareUrl}</span>
        <button
          onClick={copyLink}
          data-testid="postcard-copy-btn"
          className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-[#C8A96E] hover:text-white transition-colors"
        >
          {copied ? <><Check size={12} /> Copied</> : <><Copy size={12} /> Copy</>}
        </button>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2 sm:gap-3">
        <Button
          onClick={nativeShare}
          data-testid="postcard-native-share"
          className="bg-[#C8A96E] text-[#15111A] hover:bg-[#A98B55] rounded-none h-11 sm:h-12 uppercase tracking-widest text-[10px] sm:text-xs font-bold shadow-[0_0_24px_rgba(200,169,110,0.35)] flex items-center justify-center gap-2"
        >
          <Share2 size={16} /> Share…
        </Button>
        <Button
          onClick={downloadPng}
          data-testid="postcard-download"
          variant="outline"
          className="border-[#C8A96E]/60 bg-transparent text-[#C8A96E] hover:bg-[#C8A96E]/10 hover:text-white rounded-none h-11 sm:h-12 uppercase tracking-widest text-[10px] sm:text-xs font-bold flex items-center justify-center gap-2"
        >
          <Download size={16} /> <span className="hidden sm:inline">Download </span>PNG
        </Button>
      </div>

      <SocialShareRow shareUrl={shareUrl} imageUrl={imageUrl} caption={caption} getPngFile={getPngFile} />

    </>
  );
}
